var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (user) {
jade_mixins["settings-section"] = jade_interp = function(id, name, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("id", id, true, true)) + (jade.attr("data-id", id, true, true)) + (jade.attr("data-name", label || name, true, true)) + " class=\"settings-section js-settings-section\"><h2 class=\"settings-section__name\">" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</h2><div" + (jade.cls(['settings-section__main','js-settings-section__main--' + (id) + ''], [null,true])) + "><div" + (jade.cls(['settings-' + (id) + ''], [true])) + ">");
block && block();
buf.push("</div></div></div>");
};
jade_mixins["settings-section"].call({
block: function(){
jade_mixins["checkbox"] = jade_interp = function(name, disabled){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"settings-split artsy-checkbox\"><div class=\"settings-split__left\"><label" + (jade.attr("for", name, true, true)) + " class=\"artsy-checkbox--label js-settings-checkbox-label\">");
block && block();
buf.push("</label></div><div class=\"settings-split__right\"><div class=\"artsy-checkbox--checkbox\"><input type=\"checkbox\"" + (jade.attr("id", name, true, true)) + (jade.attr("name", name, true, true)) + (jade.attr("checked", user && user.isChecked(name), true, true)) + (jade.attr("disabled", disabled, true, true)) + "><label" + (jade.attr("for", name, true, true)) + "></label></div></div></div>");
};
buf.push("<form class=\"stacked-form\"><div class=\"form-errors js-form-errors\"></div>");
jade_mixins["checkbox"].call({
block: function(){
buf.push("I understand that this will permanently delete my account and cannot be undone.");
}
}, 'confirm');
buf.push("<label for=\"explanation\" class=\"avant-garde-form-label\">Please Tell Us Why</label><textarea id=\"explanation\" name=\"explanation\" rows=\"5\" class=\"bordered-input\"></textarea><button disabled=\"disabled\" class=\"avant-garde-button-black\">Delete My Account</button></form>");
}
}, 'delete-my-account', 'Delete My Account');
buf.push("<div class=\"settings-section\"><div class=\"settings-section__main\"><a href=\"/settings\" class=\"settings-disable-link garamond-button-text\">Cancel</a></div></div>");}.call(this,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;